import humps from 'onyx-common/humps'

const camelize = (param) => {
  return typeof param === 'string' ? humps.camelize(param) : humps.camelizeKeys(param)
}

export default camelize
